module.exports = Promise.all([parcelRequire.load("7tSlc"), parcelRequire.load("e6K7q"), parcelRequire.load("e5b67")]).then(() => parcelRequire('jsTsp'));